
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

/*global Vue*/

require('./bootstrap').default;
//require('./layout').default;
require('./cycle').default;
require('./debug').default;
require('./ios-inner-height').default;
require('./vh-fix').default;
//require('./version').default;
//require("./environment_settings").default;

//require("./offline").default;

import Echo from "laravel-echo"
window.Pusher = require('pusher-js');

if(window.api_token) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + window.api_token;
}

// console.log(JSON.decycle(window.Echo));
//
// window.Echo.connector.bind("connect", function() {
//     alert("here");
// })


import routes from './patient-routes';

window.Vue = require('vue').default;

import VueRouter from 'vue-router';
Vue.use(VueRouter);

import VueResize from 'vue-resize';
Vue.use(VueResize);

import VueAutosize from 'vue-autosize';
Vue.use(VueAutosize);

import VModal from 'vue-js-modal';
Vue.use(VModal, { dialog: true })

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue);

import Vuex from 'vuex';
Vue.use(Vuex);
import vuexI18n from 'vuex-i18n';
import Locales from './vue-i18n-locales.generated.js';

window.Locales = Locales;

import { EncryptStorage } from 'encrypt-storage';
window.EncryptStorage = EncryptStorage;

const store = new Vuex.Store();

Vue.use(vuexI18n.plugin, store);

// Copy our base brand file if we haven't got one explicitly for the current locale.
// This is okay in most cases as the brand file only contains
// proper nouns and other translation keys

Vue.i18n.add('en', Locales.en);

if(!window.Locales["cy"].brand) {
    window.Locales["cy"].brand = window.Locales["en"].brand;
}
Vue.i18n.add('cy', Locales.cy);

if(!window.Locales["fr"].brand) {
    window.Locales["fr"].brand = window.Locales["en"].brand;
}
Vue.i18n.add('fr', Locales.fr);



window.zESettings = {
    webWidget: {
        position: {
            horizontal: 'right',
            vertical: 'top'
        },
        offset: {
            horizontal: '60px',
            vertical: '-5px',
            mobile: {
                horizontal: '60px',
                vertical: '-8px'
            }
        },
        launcher: {
            chatLabel: {
              '*': 'Help'
            },
            mobile: {
                labelVisible: true
            }
        },
        color: {
            theme: '#1A72A0',
            launcher: '#1A72A0',
            launcherText: '#ffffff',
            button: '#1A72A0',
            resultLists: '#1A72A0',
            header: '#1A72A0',
            articleLinks: '#1A72A0'
        },
        chat: {
            connectOnPageLoad: false
        }
    }
}

window.addEventListener("resize",() => {
    if(document.activeElement && (document.activeElement.type == 'textarea' || document.activeElement.type == 'text' || document.activeElement.type == 'password')) {
        document.activeElement.scrollIntoView(false);
    }
    //console.log(document.activeElement.type);
});

require('./vue-prototypes').default;
//require('./version').default;

require('./vue-components').default;

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

var router = new VueRouter({
    //mode: 'history',
    mode: 'hash',
    routes: routes
});

window.routeHistory = [];
window.maxRouteHistory = 10;

router.beforeEach((to, from, next) => {
    window.routeHistory.push({to: JSON.parse(JSON.simpleStringify(to)), from: JSON.parse(JSON.simpleStringify(from)), next: JSON.parse(JSON.simpleStringify(next))});
    while(window.routeHistory.length > window.maxRouteHistory) {
        window.routeHistory.shift();
    }
    // console.log("router.beforeEach");
    // console.log(JSON.simpleStringify(from));
    // console.log(JSON.simpleStringify(to));

    if(app) {
        if(!app.loaded) {
            router.replace('/');
            return false;
        }
        if(app.$root) {
            if(app.$root.isLoggedIn()) {
                if(app.$root.user && !app.$root.user.tc_agree_date && !to.path.match(/^\/(terms)/)) {
                    app.$root.$router.push({path: "/terms/" + encodeURIComponent(to.path)});
                    return false;
                }
            }
            else {
                window.postLoginRoute = to.path;
                //alert(to.path);
                if(to.path.match(/^\/(profile|profileEdit|thread-list|thread-show|thread-create|accessType|selectCaree|oauth|campaign|select-action|proxy-select-action)\//)) {
                    //alert("Sending user to intro screen");
                    app.$root.$router.push({path: "/login/" + encodeURIComponent(to.path)});
                    return false;
                }
            }
        }
    }
    
    const DEFAULT_TITLE = 'app_name';
    Vue.nextTick(() => {
        document.title = to.meta.title ? app.$root.autobrand(to.meta.title) : app.$root.tBrandKey(DEFAULT_TITLE);
    });
    next();
})



require('./error_reporting').default;

axios.interceptors.response.use(undefined, function (error) {
    if(typeof error == "object" && error.response) {
        if(error.response.status === 401) {
            console.log("Caught authentication exception. Redirecting to login.")
            window.location = "/";
        }
        if(error.response.status === 419) {
            console.log("Session timeout. Redirecting to login.")
            window.location = "/";
        }
        // A 503 with a data object in the body, with a message, is pretty much guaranteed to be
        // maintenance mode, not a server overload.
        if(error.response.status === 503 && error.response.data && error.response.data.message) {
            console.log("Caught 503 from server, assuming maintenance mode.")
            window.location = "/";
        }
    }
    return Promise.reject(error);
});

import AppBase from './components/base/AppBase.vue';
import * as Survey from "survey-vue";


window.Survey = Survey;

var app = new Vue({
    components: {
        Survey
    },
    extends: AppBase,
    el: '#app',
    data: {
        apiBase: "/api/vp1",
        user: null,
        provider: {
            calc_service_status: -1, 
            network_service_status: 1, 
            name: "", 
            custom_action: [], 
            clinician_gender_selection_enabled: 0,
        },
        firstRoute: null,
        appStatusMessage: "",
        additionalInformation: "",
        notifications: [],
        now: Date.now(),
        connected: false,
        selfHelpSearch: "",
        practice_code: null,
        api_token: undefined,
        showEchoStatusNotifications: false,
        serviceWorkerName: '/pa-service-worker.js',
        installable: true,
        showServiceMessage: false,
        // We have a lower auto-logout for patients
        inactivityTimeout: 15 * 60 * 1000, // 15 minutes
		embed_source: null,
        back_handler: null,
    },

    router: router,
    created: function() {
        this.appStatusMessage = this.tBrand('app_name') + " " + this.$t('translations.is_loading');
        if(!this.environment_settings.MIX_ENABLE_LANGUAGE_SELECTION) {
            this.lookup.langs = {
                'en' : 'English'
            };
        }
        console.log("Capturing initial path during init: " + this.$route.path);
        if(this.$route.path == "/") {
            this.firstRoute = {path: "/intro"};
            //this.$router.push({path: "/dashboard"});
        }
        else {
            if(this.$route.path == "/loading") {
                this.firstRoute = {path: "/intro"};
            }
            else {
                this.firstRoute = {path: this.$route.path};
            }
        }
        router.replace('/');
        console.log("After init, will redirect to: " + this.firstRoute.path)

    },
    mounted: function() {
        if(this.supported_browser) {
            console.log("Initialising application");
            this.api_token = window.api_token;
            this.embed = window.embed ? window.embed : 0;

            if(window.URL) {
                var thisURL = new URL(window.location);
                if(thisURL && thisURL.searchParams) {
                    this.practice_code = thisURL.searchParams.get("c");
                    console.log("practice_code: " + this.practice_code);
					this.embed_source = thisURL.searchParams.get("source");
                    console.log("source: " + this.embed_source);
					
                }
            }
            else {
                // Don't want to include the entire URL polyfill just for the one case (looks like BING)
                // that triggers an error, so we just parse the param we want from location, loosely.
                var match = window.location.search.match(/[?&]c=([^&]*)/);

                if(match && match.length == 2) {
                    this.practice_code = match[1];
                }
            }
            if(this.practice_code) {
                try {
                    if(typeof localStorage === 'object') {
                        localStorage.setItem('practice_code', this.practice_code);
                    }
                }
                catch(e) {

                }
            }
            if(!this.isLoggedIn()) {
                console.log("Application initialised (without core)");
                //alert(this.firstRoute.path);
                //alert(this.firstRoute.path.match(/(profile|profileEdit|thread-)/));
                if(this.firstRoute.path.match(/^\/(profile|profileEdit|thread-|accessType|selectCaree)/)) {
                    this.firstRoute.path = "login/" + encodeURIComponent(this.firstRoute.path);
                }
                
                this.loadCoreMin();
            }
            else {
                this.loadCore(true);
            }

        }
        else {
            console.log("Unsupported browser detected. Refusing to run.");
        }
    },
    methods: {
        goBack() {
            if(this.back_handler) {
                this.back_handler();
            }
            else {
                this.$router.back() 
                // window.history.go(-1);
            }
            return false;
        },
        loadCoreMin() {
            var practice_code = this.$root.practice_code;
            if(practice_code == null) {
                try {
                    if(typeof localStorage === 'object') {
                        practice_code = localStorage.getItem('practice_code');
                    }
                }
                catch(e) {

                }
            }
            this.initBrowseAloud();
            var patientLookup = "patients/relatedData";
            if(practice_code) {
                patientLookup += "/" + practice_code;
            }
            axios.all([this.checkPusher(30000, false), this.loadProvider(), this.loadLookup(patientLookup)])
                .then(axios.spread((io_result, provider, userRelatedData) => {
                    //this.initEcho();
                    if(provider.data && provider.data.provider) {
                        this.mergeUpdateItem(this.provider, provider.data.provider, []);
                    }
                    else {
                        // We've got a bad practice code stored somewhere, so clear out localStorage
                        if(typeof localStorage === 'object') {
                            localStorage.removeItem('practice_code');
                        }
                    }
                    this.setBrand("patient");
                    
                    this.setLookup(userRelatedData.data);

                    //this.setServiceStatus();
                    this.setServiceMessageStatus();

                    this.loaded = true;
                    this.appvisible = true;
					
                    this.$router.replace(this.firstRoute);
                
                }))
                .catch(error => {
                    this.loaded = false;
                    this.failedToLoad = true;
                
                    //this.setLoading(false);
                    this.handleError(error, "init");
                    console.log("Application failed to load: " + JSON.stringify(error, null, 2));
                    this.appStatusMessage = this.$t("translations.application_failed_to_load");
                    this.additionalInformation = JSON.stringify(error, null, 2);
                });
                this.appvisible = true;
                
        },
        setServiceMessageStatus() {
            if(this.provider && this.provider.service_message_start_at && this.moment(this.provider.service_message_start_at) <= this.moment.now()
                    && (
                        !this.provider.service_message_end_at
                        || this.moment(this.provider.service_message_end_at) > this.moment.now()
                    )) {
                this.showServiceMessage = true;
            }
            else {
                this.showServiceMessage = false;
            }
        },
        updateTimedEvents() {
            var staff_look_ahead_days = 1;
            // if(this.moment.isoWeekDay() == 5) {
            //     staff_look_ahead_days = 3;
            // }
            for(var index in this.lookup.staff) {
                this.setAvailability(this.lookup.staff[index], staff_look_ahead_days, 14);
            }
            
            this.setServiceStatus();
            this.setServiceMessageStatus();

            for(var index in this.provider.custom_action) {
                Vue.set(this.provider.custom_action[index], "available", 0);
                switch(this.provider.custom_action[index].allow_out_of_hours) {
                    case 0:
                        this.provider.custom_action[index].available = 
                            this.$root.provider.calc_service_status == this.$root.lookup.service_status.AVAILABLE
                            || this.$root.provider.calc_service_status == this.$root.lookup.service_status.OOH_AVAILABLE;
                        break;
                    case 1:
                        this.provider.custom_action[index].available = true;
                        break;
                    case 2:
                        this.setAvailability(this.provider.custom_action[index], 0, 0, false);
                        break;
                }
            }
        },
        loadCore(init, route) {
            return axios.all([this.checkPusher(30000, false), this.loadUser(), this.loadLookup("patients/relatedData")])
                .then(axios.spread((io_result, user, userRelatedData) => {
                    this.initEcho();
                    this.initActivityMonitoring();
                    this.user = user.data.user;
                    for (var attrname in this.user.provider) {
                        //console.log("Setting " + this.items.data[index][attrname] + " to " + newItem.thread[attrname]);
                        this.provider[attrname] = this.user.provider[attrname];
                    }
                    this.setBrand("patient");
                    this.setLocale();
                    
                    this.initVideo();
                    this.initBrowseAloud();
                    this.initVisibilityHandlers();
                    this.freshdeskSetUser();

                    //this.provider = this.user.provider;
                    this.setLookup(userRelatedData.data);
                    this.initServerTime().then(() => {
                        this.updateTimedEvents();
                    });
                    

                    if(init) {
                        this.deInitChannels("private-pcore.");
                        window.Echo.private('pcore.' + this.user.provider.id)
                            .listen('PatientUpdateCore', (e) => {
                                this.setStale(true);
                                this.reloadIfStale();
                                //this.addNotification({type: "success", content: 'Core application data updated'});
                            })
                            .listen('PatientUpdateStaff', (e) => {
                                //console.info(e.staff);
                                this.addOrUpdateStaff(e.staff);
                                this.updateTimedEvents();
                                //this.addNotification({type: "success", content: 'Core application data updated'});
                            })
                            .listen('PatientRemoveStaff', (e) => {
                                //console.info(e.staff);
                                this.removeStaff(e.staff_id);
                                this.updateTimedEvents();
                                //this.addNotification({type: "success", content: 'Core application data updated'});
                            });
                            this.listenWithChunking('pcore.' + this.user.provider.id, 'PatientUpdateProvider', (e) => {
                                //console.info(e.provider, this.provider);
                                for (var attrname in e.provider) {
                                    //console.log("Setting " + this.items.data[index][attrname] + " to " + newItem.thread[attrname]);
                                    this.provider[attrname] = e.provider[attrname];
                                }
                                this.updateTimedEvents();
                                //this.addNotification({type: "success", content: 'Core application data updated'});
                            })
                            this.listenWithChunking('patient.' + this.user.id, 'UpdatePatient', (e) => {
                                //console.info(e.provider, this.provider);
                                for (var attrname in e.user) {
                                    //console.log("Setting " + this.items.data[index][attrname] + " to " + newItem.thread[attrname]);
                                    this.user[attrname] = e.user[attrname];
                                }
                                this.updateTimedEvents();
                                //this.addNotification({type: "success", content: 'User updated'});
                            });
                            /*.listen('PatientUpdateProvider', (e) => {
                                //console.info(e.provider, this.provider);
                                for (var attrname in e.provider) {
                                    //console.log("Setting " + this.items.data[index][attrname] + " to " + newItem.thread[attrname]);
                                    this.provider[attrname] = e.provider[attrname];
                                }
                                this.updateTimedEvents();
                                //this.addNotification({type: "success", content: 'Core application data updated'});
                            });*/
                            // .listen('PatientUpdateUserGroups', (e) => {
                            //     //console.info(e.provider, this.provider);
                            //     this.setLookup(e.user_groups, "user_groups");
                            //     this.updateTimedEvents();
                            //     //this.addNotification({type: "success", content: 'Core application data updated'});
                            // });
                        // window.Echo.private('pcore')
                        //     .listen('PatientUpdateNetworkCore', (e) => {
                        //         this.setStale(true);
                        //         this.reloadIfStale();
                        //         //this.addNotification({type: "success", content: 'Core application data updated'});
                        //     });
                            
                        // Update staff and service availability every 60 seconds
                        var timeoutDate = new Date();

                        setTimeout(() => {
                            setInterval(() => {
                                this.updateTimedEvents();
                            }, 60000);
                            this.updateTimedEvents();
                        }, (60 - timeoutDate.getSeconds()) * 1000);

                        this.loaded = true;
                        console.log("Application initialised");
                        console.log("route", route, "firstRoute", this.firstRoute);
                        if(route) {
                            if(route.path) {
                                route.path = decodeURIComponent(route.path);
                            }
                            this.$router.replace(route);
                        }
                        else {
                            this.$router.replace(this.firstRoute);
                        }
                        this.appvisible = true;
						
                        this.setLoading(false);
                    }
                }))
                .catch(error => {
                    //this.setLoading(false);
                    this.loaded = false;
                    this.failedToLoad = true;
                    router.replace('/');
                    this.handleError(error, "init");
                    console.error("Application failed to load");
                    // + JSON.stringify(error, null, 2)
                    console.error(error);
                    this.appStatusMessage = this.$t("translations.application_failed_to_load");
                    this.additionalInformation = error;
                });
        },
    }
});

window.app = app;
